import { useState } from 'react';
import { useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import useLzFApiCall from '@lz/services/Api';
import { useLzOnMount } from '@lz/services/Hooks';
import { lzFIsObject } from '@lz/services/Type';
import LzMUser from '@lz-models/commons/User';
import { LzTRights } from '@lz-models/commons/Rights';
import LzXCanvas from '@lz-components/commons/Canvas';
import LzXButtonsBar from '@lz-components/widgets/ButtonsBar';
import LzXRightsMatrix from '@lz-components/commons/RightsMatrix';

export interface LzPUsersRights {
  goBackRoute?: string,
}

const LzXUsersRights = (props: LzPUsersRights) => {
  const [model, setModel] = useState<LzMUser | null>(null);
  const [schema, setSchema] = useState(null);
  const [rights, setRights] = useState<LzTRights>(null);

  const routeParams = useParams();
  const lzApiCall = useLzFApiCall();

  const getRightsMutatationFree = (rights: LzTRights) => lzFIsObject(rights) ? Object.assign({}, rights) : rights;

  const userId = +(routeParams.id || 0);

  const loadRecord = async () => {
    const data = await lzApiCall('user-rights/' + userId);

    if (data && data.user && data.schema) {
      setModel(new LzMUser(data.user));
      setSchema(data.schema);
      setRights(getRightsMutatationFree(data.user.rights));
    }
  };

  // Call only for the first time when component is initially loaded
  useLzOnMount(() => {
    loadRecord();
  });

  const onReset = () => setRights(getRightsMutatationFree(model?.rights));

  const onSave = async () => {
    const data = await lzApiCall('user-rights/' + userId, { rights: rights }, 'post');
    if (data) {
      const updated = new LzMUser(Object.assign({}, model, { rights: rights }));
      setModel(updated);
    }
  };

  if (!model || !schema || !rights) {
    return <CircularProgress />;
  }

  return (
    <LzXCanvas>

      <LzXRightsMatrix
        schema={schema}
        rights={rights}
        onChange={(changed) => setRights(changed)}
      />

      <LzXButtonsBar
        buttons={[
          { title: 'Save Changes', onClick: onSave, variant: 'contained' },
          { title: 'Reload', onClick: loadRecord },
          { title: 'Reset', onClick: onReset },
          { title: 'Go Back', route: props.goBackRoute || '/system/users' },
        ]}
      />

    </LzXCanvas>
  );
};

export default LzXUsersRights;
